import { render, staticRenderFns } from "./ManualPatrol.vue?vue&type=template&id=054bb136&scoped=true"
import script from "./ManualPatrol.vue?vue&type=script&lang=ts"
export * from "./ManualPatrol.vue?vue&type=script&lang=ts"
import style0 from "./ManualPatrol.vue?vue&type=style&index=0&id=054bb136&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054bb136",
  null
  
)

export default component.exports